import { useEffect, useState } from "react";
import { useResponsive } from "@poriyaalar/custom-hooks";
import { useNavigate } from "react-router";
import { ThreeDots } from "react-loader-spinner";

export default function MutateLoader({ customHeight }) {
  const [exceed, setExceed] = useState(false);
  const { isMobile, isTab } = useResponsive();
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      setExceed(true);
    }, 30000);
  }, []);

  const handleNavigate = () => {
    navigate("/poster/home", { replace: true });
    setExceed(false);
  };

  return (
    <div
      className={`flex items-center justify-center ${
        !customHeight ? "h-screen" : ""
      } w-full bg-white`}
      style={{ height: customHeight }}
    >
      <div className="flex flex-col items-center">
        {!exceed && (
          <ThreeDots
            height="150"
            width="150"
            radius="9"
            color='var(--color-primary)'
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        )}
        {exceed && (
          <div className="flex flex-col">
            <div className="text-[4rem]">Products Not Found</div>
            <button
              className={`${
                isTab ? "text-base" : isMobile ? "text-sm" : "text-xl"
              } bg-primary-300 text-white px-8 py-5 rounded-md mt-4`}
              onClick={() => handleNavigate()}
            >
              Go to Home
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
